// extracted by mini-css-extract-plugin
module.exports = {"root":"Textarea_root__3xmgb","error":"Textarea_error__16b27","readonly":"Textarea_readonly__oxPVe","disabled":"Textarea_disabled__1PvJx"};